import { render, staticRenderFns } from "./shopsetting.vue?vue&type=template&id=3289c1e7&scoped=true&"
import script from "./shopsetting.vue?vue&type=script&lang=js&"
export * from "./shopsetting.vue?vue&type=script&lang=js&"
import style0 from "./shopsetting.vue?vue&type=style&index=0&id=3289c1e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3289c1e7",
  null
  
)

export default component.exports